export default __webpack_public_path__ + "media/images/gift_fund/monzo-ba2b5e92710d3d03ad8967e7161b1b8a.svg";